import React, { useState } from 'react'
import { CountCard } from './CountCard'
import { PieChart } from './PieChart'
import AgentListing from './AgentListing'
import { Modal } from 'antd'
import ModalFlow from './ModalFlow'
import { useNavigate } from 'react-router-dom'

const AgentMainDashboardAnalytics = () => {
  const [selectedDate, setSelectedDate] = useState<any>('Daily')
  const [isCreateTicketModalOpen, setIsCreateTicketModalOpen] = useState(false)
  const naviagte = useNavigate()

  const handleChange = (event: any) => {
    setSelectedDate(event.target.value)
  }
  const Data = {
    Daily: {
      totalNumberOfAgent: '5',
      productivity: '84.17%',
      totalHandleTimeHoursAllAgent: '29.47',
      averageConversationsPerHourByAllAgent: '3.58',
      chatStatus: {
        totalConversationByAllAgent: 120,
        totalConversationsResolvedByAllAgent: 101,
        totalConversationsEscalatedByAllAgent: 19
      },
      agentsListing: [
        {
          agentId: '1',
          status: 'ACTIVE',
          name: 'Beauty Singh​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(3).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'beautysingh@kia******.com',
          mobile: '96******78',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:10:00',
          averageConversationsPerHour: 3,
          totalConversations: 24,
          totalConversationsResolved: 19,
          resolutionPercentage: '79.17%',
          averageHandleTimeSec: 900,
          totalConversationsEscalated: 5,
          avgFirstResponseTimeSec: 20,
          totalHandleTimeHours: 6.0,
          totalHandleTimeMins: 360.0,
          avgResolutionTimeMins: 18.95,
          customerFeedbackRating: 4.5,
          occupancyGoal: '70%',
          occupancyPercentage: '94%'
        },
        {
          agentId: '2',
          status: 'INACTIVE',
          name: 'Keshav Sharma',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(4).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****2',
          email: 'keshavsharma@kia******.com',
          mobile: '92******79',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '09:12:00',
          averageConversationsPerHour: 4,
          totalConversations: 32,
          totalConversationsResolved: 29,
          resolutionPercentage: '90.63%',
          averageHandleTimeSec: 660,
          totalConversationsEscalated: 3,
          avgFirstResponseTimeSec: 25,
          totalHandleTimeHours: 5.87,
          totalHandleTimeMins: 352.0,
          avgResolutionTimeMins: 12.14,
          customerFeedbackRating: 4.2,
          occupancyGoal: '70%',
          occupancyPercentage: '92%'
        },
        {
          agentId: '3',
          status: 'ACTIVE',
          name: 'Ritik Saini​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(5).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'ritiksaini@kia******.com',
          mobile: '88******80',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:17:00',
          averageConversationsPerHour: 4,
          totalConversations: 32,
          totalConversationsResolved: 28,
          resolutionPercentage: '87.50%',
          averageHandleTimeSec: 720,
          totalConversationsEscalated: 4,
          avgFirstResponseTimeSec: 22,
          totalHandleTimeHours: 6.4,
          totalHandleTimeMins: 384.0,
          avgResolutionTimeMins: 13.71,
          customerFeedbackRating: 4.7,
          occupancyGoal: '70%',
          occupancyPercentage: '100%'
        },
        {
          agentId: '4',
          status: 'INACTIVE',
          name: 'Ankit Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(1).png',
          agentLevel: 'L2',
          employeeId: 'EMP2****4',
          email: 'ankitsharma@kia******.com',
          mobile: '96******81',
          skillset: 'L2',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:23:00',
          averageConversationsPerHour: 2,
          totalConversations: 16,
          totalConversationsResolved: 13,
          resolutionPercentage: '81.25%',
          averageHandleTimeSec: 1320,
          totalConversationsEscalated: 3,
          avgFirstResponseTimeSec: 18,
          totalHandleTimeHours: 5.87,
          totalHandleTimeMins: 352.0,
          avgResolutionTimeMins: 27.08,
          customerFeedbackRating: 4.3,
          occupancyGoal: '70%',
          occupancyPercentage: '92%'
        },
        {
          agentId: '5',
          status: 'ACTIVE',
          name: 'Avinash Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(2).png',
          agentLevel: 'L3',
          employeeId: 'EMP005',
          email: 'avinashsharma@kia******.com',
          mobile: '93******82',
          skillset: 'L3',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:41:00',
          averageConversationsPerHour: 2,
          totalConversations: 16,
          totalConversationsResolved: 12,
          resolutionPercentage: '75.00%',
          averageHandleTimeSec: 1200,
          totalConversationsEscalated: 4,
          avgFirstResponseTimeSec: 15,
          totalHandleTimeHours: 5.33,
          totalHandleTimeMins: 320.0,
          avgResolutionTimeMins: 26.67,
          customerFeedbackRating: 4.4,
          occupancyGoal: '70%',
          occupancyPercentage: '83%'
        }
      ]
    },
    Weekly: {
      totalNumberOfAgent: '5',
      productivity: '91.84%',
      totalHandleTimeHoursAllAgent: '54.07',
      averageConversationsPerHourByAllAgent: '7.79',
      chatStatus: {
        totalConversationByAllAgent: 331,
        totalConversationsResolvedByAllAgent: 304,
        totalConversationsEscalatedByAllAgent: 27
      },
      agentsListing: [
        {
          agentId: '1',
          status: 'ACTIVE',
          name: 'Beauty Singh​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(3).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'beautysingh@kia******.com',
          mobile: '96******78',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:10:00',
          averageConversationsPerHour: 3,
          totalConversations: 100,
          totalConversationsResolved: 90,
          resolutionPercentage: '90.00%',
          averageHandleTimeSec: 900,
          totalConversationsEscalated: 10,
          avgFirstResponseTimeSec: 23,
          totalHandleTimeHours: 25.0,
          totalHandleTimeMins: 1500.0,
          avgResolutionTimeMins: 16.67,
          customerFeedbackRating: 4.5
        },
        {
          agentId: '2',
          status: 'INACTIVE',
          name: 'Keshav Sharma',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(4).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****2',
          email: 'keshavsharma@kia******.com',
          mobile: '92******79',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:20:00',
          averageConversationsPerHour: 2,
          totalConversations: 92,
          totalConversationsResolved: 85,
          resolutionPercentage: '92.39%',
          averageHandleTimeSec: 660,
          totalConversationsEscalated: 7,
          avgFirstResponseTimeSec: 17,
          totalHandleTimeHours: 16.87,
          totalHandleTimeMins: 1012.0,
          avgResolutionTimeMins: 11.91,
          customerFeedbackRating: 4.2
        },
        {
          agentId: '3',
          status: 'ACTIVE',
          name: 'Ritik Saini​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(5).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'ritiksaini@kia******.com',
          mobile: '88******80',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:18:00',
          averageConversationsPerHour: 3,
          totalConversations: 112,
          totalConversationsResolved: 105,
          resolutionPercentage: '93.75%',
          averageHandleTimeSec: 720,
          totalConversationsEscalated: 7,
          avgFirstResponseTimeSec: 18,
          totalHandleTimeHours: 22.4,
          totalHandleTimeMins: 1344.0,
          avgResolutionTimeMins: 12.8,
          customerFeedbackRating: 4.7
        },
        {
          agentId: '4',
          status: 'INACTIVE',
          name: 'Ankit Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(1).png',
          agentLevel: 'L2',
          employeeId: 'EMP2****4',
          email: 'ankitsharma@kia******.com',
          mobile: '96******81',
          skillset: 'L2',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:40:00',
          averageConversationsPerHour: 3,
          totalConversations: 24,
          totalConversationsResolved: 21,
          resolutionPercentage: '87.50%',
          averageHandleTimeSec: 1320,
          totalConversationsEscalated: 3,
          avgFirstResponseTimeSec: 10,
          totalHandleTimeHours: 8.8,
          totalHandleTimeMins: 528.0,
          avgResolutionTimeMins: 25.14,
          customerFeedbackRating: 4.3
        },
        {
          agentId: '5',
          status: 'ACTIVE',
          name: 'Avinash Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(2).png',
          agentLevel: 'L3',
          employeeId: 'EMP005',
          email: 'avinashsharma@kia******.com',
          mobile: '93******82',
          skillset: 'L3',
          loginHourGoal: '08:00:00',
          actualLoginHour: '09:00:00',
          averageConversationsPerHour: 2,
          totalConversations: 3,
          totalConversationsResolved: 3,
          resolutionPercentage: '100.00%',
          averageHandleTimeSec: 1200,
          totalConversationsEscalated: 0,
          avgFirstResponseTimeSec: 12,
          totalHandleTimeHours: 1.0,
          totalHandleTimeMins: 60.0,
          avgResolutionTimeMins: 20.0,
          customerFeedbackRating: 4.4
        }
      ]
    },
    Monthly: {
      totalNumberOfAgent: '5',
      productivity: '91.57%',
      totalHandleTimeHoursAllAgent: '297.94',
      averageConversationsPerHourByAllAgent: '31.02',
      chatStatus: {
        totalConversationByAllAgent: 1328,
        totalConversationsResolvedByAllAgent: 1216,
        totalConversationsEscalatedByAllAgent: 112
      },
      agentsListing: [
        {
          agentId: '1',
          status: 'ACTIVE',
          name: 'Beauty Singh​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(3).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'beautysingh@kia******.com',
          mobile: '96******78',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:15:00',
          averageConversationsPerHour: 3,
          totalConversations: 400,
          totalConversationsResolved: 350,
          resolutionPercentage: '87.50%',
          averageHandleTimeSec: 900,
          totalConversationsEscalated: 50,
          avgFirstResponseTimeSec: 11,
          totalHandleTimeHours: 100.0,
          totalHandleTimeMins: 6000.0,
          avgResolutionTimeMins: 17.14,
          customerFeedbackRating: 4.1
        },
        {
          agentId: '2',
          status: 'INACTIVE',
          name: 'Keshav Sharma',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(4).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****2',
          email: 'keshavsharma@kia******.com',
          mobile: '92******79',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:25:00',
          averageConversationsPerHour: 2,
          totalConversations: 368,
          totalConversationsResolved: 340,
          resolutionPercentage: '92.39%',
          averageHandleTimeSec: 660,
          totalConversationsEscalated: 28,
          avgFirstResponseTimeSec: 15,
          totalHandleTimeHours: 67.47,
          totalHandleTimeMins: 4048.0,
          avgResolutionTimeMins: 11.91,
          customerFeedbackRating: 4.2
        },
        {
          agentId: '3',
          status: 'ACTIVE',
          name: 'Ritik Saini​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(5).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'ritiksaini@kia******.com',
          mobile: '88******80',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:18:00',
          averageConversationsPerHour: 3,
          totalConversations: 448,
          totalConversationsResolved: 420,
          resolutionPercentage: '93.75%',
          averageHandleTimeSec: 720,
          totalConversationsEscalated: 28,
          avgFirstResponseTimeSec: 18,
          totalHandleTimeHours: 89.6,
          totalHandleTimeMins: 5376.0,
          avgResolutionTimeMins: 12.8,
          customerFeedbackRating: 4.7
        },
        {
          agentId: '4',
          status: 'INACTIVE',
          name: 'Ankit Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(1).png',
          agentLevel: 'L2',
          employeeId: 'EMP2****4',
          email: 'ankitsharma@kia******.com',
          mobile: '96******81',
          skillset: 'L2',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:45:00',
          averageConversationsPerHour: 3,
          totalConversations: 106,
          totalConversationsResolved: 100,
          resolutionPercentage: '94.34%',
          averageHandleTimeSec: 1320,
          totalConversationsEscalated: 6,
          avgFirstResponseTimeSec: 25,
          totalHandleTimeHours: 38.87,
          totalHandleTimeMins: 2332.0,
          avgResolutionTimeMins: 23.32,
          customerFeedbackRating: 4.3
        },
        {
          agentId: '5',
          status: 'ACTIVE',
          name: 'Avinash Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(2).png',
          agentLevel: 'L3',
          employeeId: 'EMP005',
          email: 'avinashsharma@kia******.com',
          mobile: '93******82',
          skillset: 'L3',
          loginHourGoal: '08:00:00',
          actualLoginHour: '09:05:00',
          averageConversationsPerHour: 2,
          totalConversations: 6,
          totalConversationsResolved: 6,
          resolutionPercentage: '100.00%',
          averageHandleTimeSec: 1200,
          totalConversationsEscalated: 0,
          avgFirstResponseTimeSec: 22,
          totalHandleTimeHours: 2.0,
          totalHandleTimeMins: 120.0,
          avgResolutionTimeMins: 20.0,
          customerFeedbackRating: 4.4
        }
      ]
    },

    Quarterly: {
      totalNumberOfAgent: '5',
      productivity: '91.58%',
      totalHandleTimeHoursAllAgent: '893.80',
      averageConversationsPerHourByAllAgent: '94.8',
      chatStatus: {
        totalConversationByAllAgent: 3984,
        totalConversationsResolvedByAllAgent: 3648,
        totalConversationsEscalatedByAllAgent: 336
      },
      agentsListing: [
        {
          agentId: '1',
          status: 'ACTIVE',
          name: 'Beauty Singh​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(3).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'beautysingh@kia******.com',
          mobile: '96******78',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:30:00',
          averageConversationsPerHour: 3,
          totalConversations: 1200,
          totalConversationsResolved: 1050,
          resolutionPercentage: '87.50%',
          averageHandleTimeSec: 900,
          totalConversationsEscalated: 150,
          avgFirstResponseTimeSec: 18,
          totalHandleTimeHours: 300.0,
          totalHandleTimeMins: 18000.0,
          avgResolutionTimeMins: 17.14,
          customerFeedbackRating: 4.1
        },
        {
          agentId: '2',
          status: 'INACTIVE',
          name: 'Keshav Sharma',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(4).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****2',
          email: 'keshavsharma@kia******.com',
          mobile: '92******79',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:38:00',
          averageConversationsPerHour: 2,
          totalConversations: 1104,
          totalConversationsResolved: 1020,
          resolutionPercentage: '92.39%',
          averageHandleTimeSec: 660,
          totalConversationsEscalated: 84,
          avgFirstResponseTimeSec: 20,
          totalHandleTimeHours: 202.4,
          totalHandleTimeMins: 12144.0,
          avgResolutionTimeMins: 11.91,
          customerFeedbackRating: 4.2
        },
        {
          agentId: '3',
          status: 'ACTIVE',
          name: 'Ritik Saini​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(5).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'ritiksaini@kia******.com',
          mobile: '88******80',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:52:00',
          averageConversationsPerHour: 4,
          totalConversations: 1344,
          totalConversationsResolved: 1260,
          resolutionPercentage: '93.75%',
          averageHandleTimeSec: 720,
          totalConversationsEscalated: 84,
          avgFirstResponseTimeSec: 12,
          totalHandleTimeHours: 268.8,
          totalHandleTimeMins: 16128.0,
          avgResolutionTimeMins: 12.8,
          customerFeedbackRating: 4.7
        },
        {
          agentId: '4',
          status: 'INACTIVE',
          name: 'Ankit Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(1).png',
          agentLevel: 'L2',
          employeeId: 'EMP2****4',
          email: 'ankitsharma@kia******.com',
          mobile: '96******81',
          skillset: 'L2',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:02:00',
          averageConversationsPerHour: 3,
          totalConversations: 318,
          totalConversationsResolved: 300,
          resolutionPercentage: '94.34%',
          averageHandleTimeSec: 1320,
          totalConversationsEscalated: 18,
          avgFirstResponseTimeSec: 22,
          totalHandleTimeHours: 116.6,
          totalHandleTimeMins: 6996.0,
          avgResolutionTimeMins: 23.32,
          customerFeedbackRating: 4.3
        },
        {
          agentId: '5',
          status: 'ACTIVE',
          name: 'Avinash Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(2).png',
          agentLevel: 'L3',
          employeeId: 'EMP005',
          email: 'avinashsharma@kia******.com',
          mobile: '93******82',
          skillset: 'L3',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:00:00',
          averageConversationsPerHour: 2,
          totalConversations: 18,
          totalConversationsResolved: 18,
          resolutionPercentage: '100.00%',
          averageHandleTimeSec: 1200,
          totalConversationsEscalated: 0,
          avgFirstResponseTimeSec: 25,
          totalHandleTimeHours: 6.0,
          totalHandleTimeMins: 360.0,
          avgResolutionTimeMins: 20.0,
          customerFeedbackRating: 4.4
        }
      ]
    }
  }

  const filteredData: any = () => {
    switch (selectedDate) {
      case 'Daily':
        return Data?.Daily || []
      case 'Weekly':
        return Data?.Weekly || []
      case 'Monthly':
        return Data?.Monthly || []
      case 'Quarterly':
        return Data?.Quarterly || []
      default:
        return []
    }
  }
  const projectData = [filteredData()][0]
  // console.log(projectData[0].totalNumberOfChat)

  const createTicketModalOpen = () => {
    setIsCreateTicketModalOpen(true)
  }

  const createTicketModalClosed = () => {
    setIsCreateTicketModalOpen(false)
  }
  const toNaviagte = () => {
    naviagte('/report/all-report')
  }

  return (
    <div>
      <div
        id='kt_app_toolbar_container'
        className='app-container container-fluid d-flex flex-stack'
      >
        <div className='card-title col-4 align-items-start flex-row d-flex  mt-6'>
          <span className='mt-1 text-hover-primary'>
            <i
              className='bi bi-arrow-left'
              style={{ fontSize: '1.75rem' }}
              onClick={toNaviagte}
            ></i>
          </span>
          <h1
            className='page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center '
            style={{ marginLeft: '10px', marginTop: '4px' }}
          >
            KPI Dashboard
          </h1>
        </div>
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <div>
            <label>Project:</label>
            <select
              className='form-select  form-select '
              name='industryType'
              value={'KIA'}
              style={{ width: '200px' }}
            >
              <option hidden>Select</option>
              <option value='KIA'>KIA</option>
            </select>
          </div>
          <div>
            <label>Date:</label>
            <select
              className='form-select  form-select '
              name='industryType'
              value={selectedDate}
              onChange={handleChange}
              style={{ width: '200px' }}
            >
              <option hidden>Select</option>
              <option value='Daily'>Daily</option>
              <option value='Weekly'>Weekly</option>
              <option value='Monthly'>Monthly</option>
              <option value='Quarterly'>Quarterly</option>
            </select>
          </div>
          <div>
            <div
              className='btn btn-sm btn-primary me-3'
              style={{ marginTop: '20px' }}
              onClick={createTicketModalOpen}
            >
              <span className='svg-icon svg-icon-3'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className='mh-50px'
                >
                  <rect
                    opacity='0.5'
                    x='11.364'
                    y='20.364'
                    width='16'
                    height='2'
                    rx='1'
                    transform='rotate(-90 11.364 20.364)'
                    fill='black'
                  ></rect>
                  <rect x='4.36396' y='11.364' width='16' height='2' rx='1' fill='black'></rect>
                </svg>
              </span>
              Add KPI
            </div>
          </div>
        </div>
      </div>
      <div className='row g-4 mb-4' style={{ marginTop: '20px' }}>
        <CountCard
          title='Agents In Campaign'
          value={projectData?.totalNumberOfAgent}
          percentage=''
          iconClass='bx-user'
          bgClass='bg-label-primary'
          cardStyle='#FC4065'
        />
        <CountCard
          title='Total Conversation Time'
          value={projectData?.totalHandleTimeHoursAllAgent}
          percentage=''
          iconClass='bx-user-check'
          bgClass='bg-label-danger'
          cardStyle='#ec9d15'
        />

        <CountCard
          title='Case Resolved Percentage'
          value={projectData.productivity}
          percentage=''
          iconClass='bx-user-check'
          bgClass='bg-label-danger'
          cardStyle='#93918d'
        />
        <CountCard
          title='Total Conversation'
          value={Number(projectData?.chatStatus?.totalConversationByAllAgent)}
          percentage=''
          iconClass='bx-user-voice'
          bgClass='bg-label-warning'
          cardStyle='#9923be'
        />
        <CountCard
          title='Total Conversation Resolved'
          value={projectData?.chatStatus?.totalConversationsResolvedByAllAgent}
          percentage=''
          iconClass='bx-user-voice'
          bgClass='bg-label-warning'
          cardStyle='#2393be'
        />
        <CountCard
          title='Total Conversation Escalated'
          value={projectData?.chatStatus?.totalConversationsEscalatedByAllAgent}
          percentage=''
          iconClass='bx-group'
          bgClass='bg-label-success'
          cardStyle='#3bc238'
        />
      </div>
      <div className='row gy-2 g-xl-12'>
        <PieChart chatStatus={projectData?.chatStatus} />
        <AgentListing agentListing={projectData?.agentsListing} />
      </div>

      <Modal
        title='Add Detail'
        open={isCreateTicketModalOpen}
        onCancel={createTicketModalClosed}
        footer={null}
        destroyOnClose
      >
        <ModalFlow createTicketModalClosed={createTicketModalClosed} />

        <Modal />
      </Modal>
    </div>
  )
}

export default AgentMainDashboardAnalytics
